import { useEffect, useState } from "react";
import CannedResponseHeader from "../common/CannedResponseHeader/CannedResponseHeader";
import CannedResponsesTab from "../common/CannedResponsesTab/CannedResponsesTab";
import CannedRRTable from "./CannedRRTable/CannedRRTable";
import { dataQueryStatus } from "utils";
import { CANNED_RESOURCE_ACTIONS, CANNED_RESOURCE_TYPES } from "../enum";
import { apiRoute } from "services";
import API from "services/lib/api";
import { getErrorMessage, getPageFromCache } from "utils/helper";
import { Empty, Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import CustomPagination from "components/dashboard/common/CustomPagination/CustomPagination";
import CannedResourceModal from "../common/modal/CannedResourceModal/CannedResourceModal";
import { useDispatch, useSelector } from "react-redux";
import { setCannedRepliesFilterParams } from "store/filters/actions";
import {
    clearCannedReplies,
    saveCannedReplies,
} from "store/modules/agentAssistance/actions";

const { IDLE, LOADING, ERROR, DATAMODE, NULLMODE } = dataQueryStatus;

const { CREATE_CANNED_RESOURCE, EDIT_CANNED_RESOURCE } =
    CANNED_RESOURCE_ACTIONS;

const CannedRepliesResponses = () => {
    const [errorMssg, setErrorMssg] = useState();
    const [showModal, toggleModal] = useState(false);
    const [cannedReplies, setCannedReplies] = useState([]);

    const [selectedCannedResource, selectCannedResource] = useState();
    const [modalAction, setModalAction] = useState();

    const [tableIsLoading, setTableIsLoading] = useState(false);
    const [useTableLoader, setUseTableLoader] = useState(false);
    const [searchIsLoading, setSearchIsLoading] = useState(false);
    const [clearSearch, setClearSearch] = useState(false);

    const {
        cannedRepliesCache: { pages, totalRecords },
    } = useSelector((state) => state.agentAssistance);

    const { filterParams } = useSelector(
        (state) => state?.filters?.cannedRepliesFilters
    );

    const [status, setStatus] = useState(
        pages[filterParams?.currentPage]?.length > 0 ? DATAMODE : IDLE
    );

    const cannedResourceType = CANNED_RESOURCE_TYPES?.CANNED_RESPONSE;

    const dispatch = useDispatch();

    const handleSearch = (search) => {
        setUseTableLoader(true);
        setSearchIsLoading(true);
        setClearSearch(false);

        dispatch(setCannedRepliesFilterParams({ currentPage: 1, search }));
        dispatch(clearCannedReplies());
    };

    const handlePageChange = (currentPage) => {
        setUseTableLoader(true);

        dispatch(
            setCannedRepliesFilterParams({ ...filterParams, currentPage })
        );
    };

    const getCannedReplies = async () => {
        try {
            setErrorMssg();
            useTableLoader && setTableIsLoading(true);
            if (cannedReplies?.length < 1 && filterParams?.search < 1) {
                setStatus(LOADING);
            }
            const url = apiRoute.getCannedResources;
            const res = await API.get(url, {
                params: {
                    cannedResourceType,
                    ...filterParams,
                },
            });

            if (res.status === 200) {
                filterParams?.search?.length > 0 && setUseTableLoader(true);
                const { data, metaData } = res.data;
                let newStatus = data.length > 0 ? DATAMODE : NULLMODE;
                setCannedReplies(data);

                dispatch(
                    saveCannedReplies(
                        filterParams?.currentPage,
                        metaData?.totalRecords,
                        data
                    )
                );
                setStatus(newStatus);
                setSearchIsLoading(false);
                setTableIsLoading(false);
            }
        } catch (err) {
            setSearchIsLoading(false);
            setErrorMssg(getErrorMessage(err));
            useTableLoader ? setTableIsLoading(false) : setStatus(ERROR);
        }
    };

    const handleSuccess = () => {
        dispatch(setCannedRepliesFilterParams({ currentPage: 1, search: "" }));
        dispatch(clearCannedReplies());
        setClearSearch(true);
        getCannedReplies();
    };

    const handleActionModal = (actionType, cannedResource) => {
        setModalAction(actionType);
        selectCannedResource(cannedResource);
        toggleModal(true);
    };

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return "";

            case LOADING:
                return <Loading />;

            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getCannedReplies}
                    />
                );

            case NULLMODE:
                return <Empty text={"No Canned Resource Available Yet"} />;

            case DATAMODE:
                return (
                    <>
                        <CannedRRTable
                            handleSuccess={handleSuccess}
                            handleActionModal={handleActionModal}
                            modalAction={modalAction}
                            cannedReplies={cannedReplies}
                            tableIsLoading={tableIsLoading}
                        />
                        <CustomPagination
                            totalRecords={totalRecords}
                            handlePageChange={handlePageChange}
                            {...filterParams}
                        />
                    </>
                );

            default:
                return "";
        }
    };

    useEffect(() => {
        const cachedPage = getPageFromCache(pages, filterParams.currentPage);
        if (cachedPage?.length > 0 && !searchIsLoading) {
            setCannedReplies(cachedPage);
        } else {
            getCannedReplies();
        }
        // eslint-disable-next-line
    }, [filterParams, useTableLoader]);

    const isEdit = modalAction === EDIT_CANNED_RESOURCE;

    return (
        <>
            <CannedResponsesTab />
            <div className='padded__layout'>
                <CannedResponseHeader
                    title={"Canned replies"}
                    subTitle={"Add and edit canned replies"}
                    btnText={"Create new canned reply"}
                    placeholder='Search replies here'
                    handleClick={() =>
                        handleActionModal(CREATE_CANNED_RESOURCE)
                    }
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    defaultValue={filterParams?.search}
                />
                {renderBasedOnStatus()}
            </div>

            {showModal && (
                <CannedResourceModal
                    title={isEdit ? "Update Canned Reply" : "New Canned Reply"}
                    showModal={showModal}
                    closeModal={() => toggleModal(false)}
                    cannedResourceType={cannedResourceType}
                    toggleModal={toggleModal}
                    modalAction={modalAction}
                    selectedCannedResource={selectedCannedResource}
                    handleSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default CannedRepliesResponses;
